import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';

import './App.css';
import 'maplibre-gl/dist/maplibre-gl.css';

import AppContainer from './containers';

function App() {
  return (
    <RecoilRoot>
      <BrowserRouter>
        <AppContainer />
      </BrowserRouter>
    </RecoilRoot>
  );
}

export default App;
